import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'theme',
      'roles'
    ]),
    fullscreenLoading () {
      if (this.roles) {
        return false
      }
      return true
    }
  }
}
